import { render } from "./AVGHeader.vue?vue&type=template&id=001011ac&scoped=true"
import script from "./AVGHeader.vue?vue&type=script&lang=js"
export * from "./AVGHeader.vue?vue&type=script&lang=js"

import "./AVGHeader.vue?vue&type=style&index=0&id=001011ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001011ac"]])

export default __exports__